import { createAction, props } from '@ngrx/store';
import { AuditDto, AuditStatus } from '../../../api';
import { AuditListItemDto } from './audit-list-item.model';

/**
 * Audit Actions
 * 
 * These actions represent all events that can happen in the audit feature.
 * Pattern: [Source] Event Description
 */

// Load Audits
export const loadAudits = createAction('[Audits Page] Load Audits');

/** Silent background refresh triggered by SignalR – list stays visible */
export const refreshAudits = createAction('[Audits Realtime] Refresh Audits');

export const loadAuditsSuccess = createAction(
  '[Audits API] Load Audits Success',
  props<{ audits: AuditListItemDto[] }>()
);

export const loadAuditsFailure = createAction(
  '[Audits API] Load Audits Failure',
  props<{ error: string }>()
);

// Load Single Audit
export const loadAudit = createAction(
  '[Audit Detail Page] Load Audit',
  props<{ auditId: string }>()
);

export const loadAuditSuccess = createAction(
  '[Audits API] Load Audit Success',
  props<{ audit: AuditDto }>()
);

export const loadAuditFailure = createAction(
  '[Audits API] Load Audit Failure',
  props<{ error: string }>()
);

// Create Audit
export const createAudit = createAction(
  '[Audit Form] Create Audit',
  props<{ audit: AuditDto }>()
);

export const createAuditSuccess = createAction(
  '[Audits API] Create Audit Success',
  props<{ audit: AuditDto }>()
);

export const createAuditFailure = createAction(
  '[Audits API] Create Audit Failure',
  props<{ error: string }>()
);

// Delete Audit
export const deleteAudit = createAction(
  '[Audit Actions] Delete Audit',
  props<{ auditId: string }>()
);

export const deleteAuditSuccess = createAction(
  '[Audits API] Delete Audit Success',
  props<{ auditId: string }>()
);

export const deleteAuditFailure = createAction(
  '[Audits API] Delete Audit Failure',
  props<{ error: string }>()
);

// Clear Selected Audit
export const clearSelectedAudit = createAction('[Audits] Clear Selected Audit');

// Update Audit Status
export const updateAuditStatus = createAction(
  '[Audit Detail] Update Audit Status',
  props<{ auditId: string; status: AuditStatus }>()
);

export const updateAuditStatusSuccess = createAction(
  '[Audits API] Update Audit Status Success',
  props<{ auditId: string; status: AuditStatus }>()
);

export const updateAuditStatusFailure = createAction(
  '[Audits API] Update Audit Status Failure',
  props<{ error: string }>()
);

// Bulk Update Audit Status
export const bulkUpdateAuditStatus = createAction(
  '[Audits Page] Bulk Update Audit Status',
  props<{ auditIds: string[]; status: AuditStatus }>()
);

export const bulkUpdateAuditStatusSuccess = createAction(
  '[Audits API] Bulk Update Audit Status Success',
  props<{ auditIds: string[]; status: AuditStatus }>()
);

export const bulkUpdateAuditStatusFailure = createAction(
  '[Audits API] Bulk Update Audit Status Failure',
  props<{ error: string }>()
);

// Bulk Delete Audits
export const bulkDeleteAudits = createAction(
  '[Audits Page] Bulk Delete Audits',
  props<{ auditIds: string[] }>()
);

export const bulkDeleteAuditsSuccess = createAction(
  '[Audits API] Bulk Delete Audits Success',
  props<{ auditIds: string[] }>()
);

export const bulkDeleteAuditsFailure = createAction(
  '[Audits API] Bulk Delete Audits Failure',
  props<{ error: string }>()
);